module.exports = __webpack_public_path__ + "static/media/iphonex-flat.918658b4.png";